<div class="fx-row w-full fx-center py-2 gap-source-selector">
  <div
    *ngIf="options.includes('solar')"
    class="fx-center light pointer rounded select-item-size fx-col bg-orange-100"
    [ngClass]="{
      'opacity-80': !source.includes('solar'),
      'solar-shadow': source.includes('solar')
    }"
    (click)="clickNode('solar')">
    <ion-icon
      class="select-item-icon-size"
      src="cmp-assets/solar.svg">
    </ion-icon>
  </div>
  <div
    *ngIf="options.includes('battery')"
    class="fx-center light pointer rounded select-item-size fx-col bg-green-100"
    [ngClass]="{
      'opacity-80': !source.includes('battery'),
      'battery-shadow': source.includes('battery')
    }"
    (click)="clickNode('battery')">
    <ion-icon
      class="select-item-icon-size"
      src="cmp-assets/battery.svg">
    </ion-icon>
  </div>
  <div
    *ngIf="options.includes('grid')"
    class="fx-center light pointer rounded select-item-size fx-col bg-grey-100"
    [ngClass]="{
      'opacity-80': !source.includes('grid'),
      'grid-shadow': source.includes('grid')
    }"
    (click)="clickNode('grid')">
    <ion-icon
      class="select-item-icon-size"
      src="cmp-assets/grid.svg">
    </ion-icon>
  </div>
  <div
    *ngIf="options.includes('home')"
    class="fx-center light pointer rounded select-item-size fx-col bg-blue-100"
    [ngClass]="{
      'opacity-80': !source.includes('home'),
      'home-shadow': source.includes('home')
    }"

    (click)="clickNode('home')">
    <ion-icon      class="select-item-icon-size"
      src="cmp-assets/home.svg">
    </ion-icon>
  </div>
</div>
